import script from "./ReviewGallery.vue?vue&type=script&setup=true&lang=js"
export * from "./ReviewGallery.vue?vue&type=script&setup=true&lang=js"

import "./ReviewGallery.vue?vue&type=style&index=0&id=9a31efcc&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9a31efcc"]])

export default __exports__